import { Autocomplete, Box, TextField, Tooltip, Typography } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './orderAutocomplete.module.scss';
import { useThunk } from './useThunk';
import { getLabel } from './thunk';
/**
 * OrderAutocomplete Component
 *
 * A reusable autocomplete component for searching orders by ID.
 * It encapsulates the fetching logic and handles debounce internally via useThunk hook.
 */
const OrderAutocomplete = ({
  value,
  onChange,
  onSelect,
  onAssignable,
  organisationId,
  warehouseId,
  setError,
  label = 'Order #',
  placeholder,
  required = false,
  ...rest
}) => {
  const {
    options,
    loading,
    inputValue,
    handleInputChange,
    assignedTicket,
    handleCheckAssignable,
    assignedTicketLink,
    handleBlur,
    setInputValue,
  } = useThunk({ value, organisationId, warehouseId, setError, onAssignable });

  React.useEffect(() => {
    onChange('');
    setInputValue('');
    if (setError) {
      setError(null);
    }
  }, [organisationId, warehouseId]);

  const handleInternalChange = (event, newValue) => {
    // If it's an array, the first element is usually the ID
    const valueToEmit = Array.isArray(newValue) ? newValue[0] : (newValue || '');
    onChange(String(valueToEmit));
    if (onSelect) {
      onSelect(newValue);
    }
    handleCheckAssignable(valueToEmit);
  };

  return (
    <Box>
      <Autocomplete
        {...rest}
        freeSolo
        options={options}
        loading={loading}
        inputValue={inputValue}
        // noOptionsText={inputValue.length < 4 ? 'Type at least 4 characters' : 'No orders found'}
        getOptionLabel={getLabel}
        onInputChange={handleInputChange}
        onChange={handleInternalChange}
        onBlur={handleBlur}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            required={required}
            variant='outlined'
            placeholder={placeholder || 'Search Order #'}
          />
        )}
      />
      {assignedTicket && (
        <Typography className={styles.warningText}>
          An {assignedTicket.category ? ` ${assignedTicket.category}` : ''} ticket already associated to this
          order: <Link target='_blank' rel='noopener noreferrer'
            to={assignedTicketLink}
            className='rt-link'>{assignedTicket.id}</Link>
        </Typography>
      )}
    </Box>
  );
};

export default OrderAutocomplete;
